interface Route {
  name: string;
  nameAlt?: string;
  url: string;
}

export const omEntur: Route = {
  name: 'menu.omEntur',
  url: '/om-entur',
};
export const omEnturBeta: Route = {
  name: 'menu.omEntur',
  url: '/beta/om-entur',
};

export const jobbientur: Route = {
  name: 'menu.jobbIEntur',
  url: '/jobb-i-entur',
};

export const presse: Route = { name: 'menu.presse', url: '/presse' };

export const arsrapporter: Route = {
  name: 'bedrift.arsrapporter.menuheading',
  url: '/presse/arsrapporter',
};

export const entursTjenester: Route = {
  name: 'menu.entursTjenester',
  url: '/enturs-tjenester',
};

export const komIGang: Route = {
  name: 'menu.komIGang',
  url: '/kom-i-gang',
};

export const ledelsenIEntur: Route = {
  name: 'menu.ledelsenIEntur',
  url: '/ledelsen-i-entur',
};

export const forLeverandorer: Route = {
  name: 'menu.forLeverandorer',
  url: '/for-leverandorer',
};

export const transportorer: Route = {
  name: 'menu.transportorer',
  url: '/transportorer',
};

export const aktuelleSaker: Route = {
  name: 'menu.aktuelt',
  url: '/aktuelle-saker',
};

export const inerheten: Route = {
  name: 'menu.nerheten',
  url: 'https://www.entur.no/avgangstavle',
};

export const personvern: Route = {
  name: 'menu.personvern',
  url: '/personvern',
};

export const vilkar: Route = {
  name: 'menu.vilkar',
  url: '/vilkar',
};

export const nettstedkart: Route = {
  name: 'footer.nettstedkart',
  url: '/nettstedkart',
};

// om reiseplanleggeren, ikke selve reiseplanleggeren
export const omReiseplanleggeren: Route = {
  name: 'menu.reiseplanleggeren',
  url: '/om-reiseplanleggeren',
};

export const omReiseplanleggerenHjem: Route = {
  name: 'menu.reiseplanleggerenHjem',
  url: '/om-reiseplanleggeren/hjem',
};

export const omReiseplanleggerenKart: Route = {
  name: 'menu.reiseplanleggerenKart',
  url: '/om-reiseplanleggeren/kart',
};

export const omReiseplanleggerenBilletter: Route = {
  name: 'menu.reiseplanleggerenBilletter',
  url: '/om-reiseplanleggeren/billetter',
};

export const omReiseplanleggerenAvganger: Route = {
  name: 'menu.reiseplanleggerenAvganger',
  url: '/om-reiseplanleggeren/avganger',
};

export const omReiseplanleggerenMer: Route = {
  name: 'menu.reiseplanleggerenMer',
  url: '/om-reiseplanleggeren/mer',
};

export const lastnedapp: Route = {
  name: 'menu.lastnedapp',
  url: '/last-ned-appen',
};

export const togIEuropa: Route = {
  name: 'menu.togIEuropa',
  url: '/tog-i-europa',
};

export const ofteStilteSporsmal: Route = {
  name: 'menu.Faq',
  url: '/ofte-stilte-sporsmal',
};

export const assistanse: Route = {
  name: 'menu.assistanse',
  url: '/assistanse',
};

export const betjentestasjoner: Route = {
  name: 'menu.betjenteStasjoner',
  url: '/betjente-stasjoner',
};

export const gruppereiser: Route = {
  name: 'menu.gruppereiser',
  url: '/gruppereiser',
};

export const hittegods: Route = {
  name: 'menu.hittegods',
  url: '/hittegods',
};

export const kontaktOss: Route = {
  name: 'menu.kontaktOss',
  nameAlt: 'menu.kontaktKundesenter',
  url: 'https://entur.no/kontakt-oss',
};

export const personalbillett: Route = {
  name: 'menu.personalbillett',
  url: '/personalbillett',
};

export const reisesok: Route = {
  name: 'menu.reisesok',
  url: 'https://www.entur.no/',
};

export const kart: Route = {
  name: 'menu.kart',
  url: 'https://www.entur.no/kart',
};

// Andre lenker
export const utviklerportal: Route = {
  name: 'footer.dev',
  url: 'https://developer.entur.org/',
};

export const tjenester: Route = {
  name: 'footer.services',
  url: 'https://om.entur.no/kom-i-gang/',
};

export const datakatalog: Route = {
  name: 'footer.datakatalog',
  url: 'https://data.entur.no/',
};

export const incidentPortal: Route = {
  name: 'footer.incident',
  url: 'https://portal.mittvarsel.no/skjema/entur/UbYSWivmJNVTeAxE.939',
};

export const designPortal: Route = {
  name: 'footer.designsystem',
  url: `https://design.entur.org/`,
};

export const onelinkDownload: Route = {
  name: 'reisende.getApp.mobileDownload',
  url: 'http://onelink.to/35ex24',
};

export const presserom: Route = {
  name: 'no name for this link, get name from sanity', // does not need a name, name gets taken from sanity
  url: 'https://kommunikasjon.ntb.no/presserom/entur/r?publisherId=15567118',
};

export const logoer: Route = {
  name: 'no name for this link, get name from sanity', // does not need a name, name gets taken from sanity
  url: 'https://design.entur.org/identitet/verktoykassen/logo',
};

export const trafikkmeldinger: Route = {
  name: 'menu.trafikkmeldinger',
  url: '/trafikkmeldinger',
};
